import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import Exception from "../../shared/exception/Exception";
import {RTFJS} from "rtf.js";
import Translate from "../../shared/translation/Translate";
import FunctionHelper from "../../shared/helper/FunctionHelper";

export default class RtfContainer extends AbstractContainer {
	public clean(): void {
		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument): Promise<RTFJS.Document> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		if (this.loaded) {
			return this.data;
		}

		try {
			this.data = new RTFJS.Document(this.data, {});
			this.loaded = true;
		} catch (exception: any) {
			let portalException: Exception = new Exception(exception.message);
			portalException.originalException = exception;
			throw portalException;
		}

		return this.data;
	}

	public async getNumberOfPages() {
		return 1;
	}

	public getType(): ViewerType {
		return ViewerType.RTF;
	}
}